// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyC-EX7ISXOLtcLYxEX7JbSFU-pY4D9h9oI",
  authDomain: "frostville-4e413.firebaseapp.com",
  projectId: "frostville-4e413",
  storageBucket: "frostville-4e413.firebasestorage.app",
  messagingSenderId: "488619986347",
  appId: "1:488619986347:web:3013915207a2954d5116ee",
  measurementId: "G-6VLCJLX2WX"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig, "frostville");
const analytics = getAnalytics(app);
export const db8 = getFirestore(app); 